import { useEffect, useRef, useState } from "react";

const ColumnSelector = ({ fields, toggleFieldVisibility }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(() => {
    // Check if the user has interacted with the column selector before
    return localStorage.getItem("hasInteractedWithColumnSelector") === "true";
  });
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Mark as interacted when the user opens the dropdown
  useEffect(() => {
    if (isOpen && !hasInteracted) {
      setHasInteracted(true);
      localStorage.setItem("hasInteractedWithColumnSelector", "true");
    }
  }, [isOpen, hasInteracted]);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        data-attr="column-selector"
        onClick={() => setIsOpen(!isOpen)}
        className="text-primary hover:text-slate-600 rounded-lg p-1 transition duration-300"
        title="Customize Columns"
        aria-label="Customize table columns"
      >
        <div className="relative">
          <svg
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          {!hasInteracted && (
            <span className="absolute -top-2 -right-2 w-3 h-3 bg-orange-500 rounded-full z-[250]"></span>
          )}
        </div>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-border rounded-lg shadow-sm z-10">
          {fields.map((field) => (
            <label
              key={field.key}
              className="flex items-center px-4 py-2 hover:bg-accent-teal-subtle"
            >
              <input
                type="checkbox"
                checked={field.visible}
                onChange={() => toggleFieldVisibility(field.key)}
                className="mr-2"
              />
              {field.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnSelector;